import * as React from 'react'
import { css } from '@emotion/react'
import { NextPage } from 'next'
import { Template } from '@/components/common/Template'
import Head from 'next/head'

const ContactPage: NextPage = () => {
  return (
    <>
      <Head>
        <title>お問い合わせ - スピーダ スタートアップ情報リサーチ</title>
      </Head>
      <Template>
        <iframe
          src="https://docs.google.com/forms/d/e/1FAIpQLSeVMfLIvpsh7_Cju-MiAr7Bw743kSUurUpNrew3jOs_Q1DbBQ/viewform?embedded=true"
          css={css`
            width: 100%;
            min-height: 100vh;
            height: auto;
          `}
        />
      </Template>
    </>
  )
}

export default ContactPage
